import { render, staticRenderFns } from "./VFairDetails.vue?vue&type=template&id=45d65af4&scoped=true"
import script from "./VFairDetails.vue?vue&type=script&lang=ts"
export * from "./VFairDetails.vue?vue&type=script&lang=ts"
import style0 from "./VFairDetails.vue?vue&type=style&index=0&id=45d65af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d65af4",
  null
  
)

export default component.exports